export default ".user-dropdown[data-v-cecbd594] { z-index: 11;\n}\n"